import { render, staticRenderFns } from "./DeliveryDashboard.vue?vue&type=template&id=e97ac1de&scoped=true"
import script from "./DeliveryDashboard.vue?vue&type=script&lang=js"
export * from "./DeliveryDashboard.vue?vue&type=script&lang=js"
import style0 from "./DeliveryDashboard.vue?vue&type=style&index=0&id=e97ac1de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97ac1de",
  null
  
)

export default component.exports